import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ApiService } from './services/api.service';

@Component({
    selector: 'big-chat-core-bot-rating',
    template: '',
    standalone: false,
})
export class ChatCoreBotRatingComponent {
    public currentRating = 0;

    protected api = inject(ApiService);
    protected destroyRef = inject(DestroyRef);

    public rateConversation(value: number): void {
        this.currentRating = value;
        this.api.rateConversation(value)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe();
    }
}
